import { t } from "@repo/translation";
import { FilterCheckbox } from "@repo/ui";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const InstallationQuotationExistsFilter = ({
  actions,
  filters,
}: FilterItemsProps) => {
  return (
    <FilterListContainer id="installation-quotation-exists-filter">
      <FilterCheckbox
        id={filters.installationQuotationExists}
        value="have_installation_quotation"
        label={t("label.have_installation_quotation")}
        checked={filters.installationQuotationExists === true}
        onCheckFilter={(_, checked) => {
          if (checked) {
            actions.setInstallationQuotationExists(true);
            return;
          }

          actions.setInstallationQuotationExists(undefined);
        }}
      />
      <FilterCheckbox
        id={filters.installationQuotationExists}
        value="no_installation_quotation"
        label={t("label.no_installation_quotation")}
        checked={filters.installationQuotationExists === false}
        onCheckFilter={(_, checked) => {
          if (checked) {
            actions.setInstallationQuotationExists(false);
            return;
          }

          actions.setInstallationQuotationExists(undefined);
        }}
      />
    </FilterListContainer>
  );
};
